import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { PDFInvoicesRootModule, PDF_INVOICES_FEATURE } from '@spartacus/pdf-invoices/root';

@NgModule({
  declarations: [],
  imports: [PDFInvoicesRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [PDF_INVOICES_FEATURE]: {
          module: () => import('@spartacus/pdf-invoices').then((m) => m.PDFInvoicesModule),
        },
      },
    }),
  ],
})
export class PdfinvoicesModuleFeatureModule {}
